import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, Container, Paper, Alert, CircularProgress } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useGroceryData } from './useGroceryData';
import { Helmet } from 'react-helmet-async';

const GroceryLiveView = () => {
    const { activeItems, loading } = useGroceryData();
    const [copySuccess, setCopySuccess] = useState(false);
    const [listText, setListText] = useState('');

    useEffect(() => {
        if (activeItems) {
            const text = activeItems
                .map(item => `- ${item.name}`)
                .join('\n');
            setListText(text);
        }
    }, [activeItems]);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(listText);
            setCopySuccess(true);
            setTimeout(() => setCopySuccess(false), 3000);
        } catch (err) {
            console.error('Failed to copy', err);
        }
    };

    if (loading) {
        return (
            <Box sx={{ minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', bgcolor: '#f7fafc' }}>
                <CircularProgress sx={{ color: '#ed8936' }} />
            </Box>
        );
    }

    return (
        <Box 
            sx={{ 
                minHeight: '100vh', 
                bgcolor: '#f7fafc',
                py: 4
            }}
        >
            <Helmet>
                <title>Live Grocery List</title>
            </Helmet>

            <Container maxWidth="sm">
                <Box sx={{ textAlign: 'center', mb: 4 }}>
                    <Typography variant="h4" fontWeight="900" color="#ed8936" gutterBottom>
                        LIVE LIST
                    </Typography>
                    <Typography variant="body1" color="text.secondary">
                        Connected to Family Database
                    </Typography>
                </Box>

                <Paper 
                    elevation={0}
                    sx={{ 
                        p: 3, 
                        borderRadius: 4, 
                        border: '1px solid #e2e8f0',
                        bgcolor: 'white',
                        mb: 4
                    }}
                >
                    {activeItems.length === 0 ? (
                        <Typography color="text.secondary" textAlign="center" fontStyle="italic">
                            List is empty!
                        </Typography>
                    ) : (
                        <pre style={{ 
                            whiteSpace: 'pre-wrap', 
                            fontFamily: 'inherit',
                            fontSize: '1.1rem',
                            margin: 0,
                            color: '#2d3748'
                        }}>
                            {listText}
                        </pre>
                    )}
                </Paper>

                <Button
                    variant="contained"
                    fullWidth
                    size="large"
                    onClick={handleCopy}
                    disabled={activeItems.length === 0}
                    startIcon={copySuccess ? <CheckCircleIcon /> : <ContentCopyIcon />}
                    sx={{
                        py: 2.5,
                        fontSize: '1.2rem',
                        fontWeight: 'bold',
                        borderRadius: 3,
                        bgcolor: copySuccess ? '#48bb78' : '#ed8936',
                        '&:hover': {
                            bgcolor: copySuccess ? '#38a169' : '#dd6b20'
                        },
                        boxShadow: '0 4px 14px 0 rgba(0,0,0,0.1)'
                    }}
                >
                    {copySuccess ? "COPIED TO CLIPBOARD!" : "COPY TO CLIPBOARD"}
                </Button>

                {copySuccess && (
                    <Alert severity="success" sx={{ mt: 3, borderRadius: 2 }}>
                        Text copied! Switch to Google Keep or Notes to paste it.
                    </Alert>
                )}

            </Container>
        </Box>
    );
};

export default GroceryLiveView;
